import { createAction, props } from '@ngrx/store';
import { IPortalLink } from '@nha/api/core';

export const LoadPortalLinks = createAction('[PortalLinks] Load Portal Links');
export const SetPortalLinks = createAction('[PortalLinks] Set Portal Links', props<{ portalLinks: IPortalLink[] }>());

export const SetFavorite = createAction('[PortalLinks] Set Favorite', props<{ portalLinkID: number; isFavorite: boolean }>());
export const UpdateFavorites = createAction('[PortalLinks] Update Favorites', props<{ portalLinkIDs: number[] }>());

export const updateFavoritesOrder = createAction('[PortalLinks] Update Favorites Order', props<{ portalLinks: IPortalLink[] }>());
export const updateFavoritesOrderSuccess = createAction('[PortalLinks] Update Favorites Order Success', props<{ portalLinks: IPortalLink[] }>());
export const updateFavoritesOrderFail = createAction('[PortalLinks] Update Favorites Order Failure', props<{ err: Error }>());

export const updateQuickLinksOrder = createAction('[PortalLinks] Update Quick Links Order', props<{ portalLinks: IPortalLink[] }>());
export const updateQuickLinksOrderSuccess = createAction('[PortalLinks] Update Quick Links Order Success', props<{ portalLinks: IPortalLink[] }>());
export const updateQuickLinksOrderFail = createAction('[PortalLinks] Update Quick Links Order Failure', props<{ err: Error }>());
